export default __webpack_public_path__ + "1765dff4268c248a92341732238b6979.png";